import * as React from "react"
import { Box, Typography, CircularProgress } from "@mui/material"
import { useQuery } from "react-query"
import Stats from "../components/stats/Stats"

async function fetchStatsData() {
  const res = await fetch(
    `${process.env.REACT_APP_API_BASE_URL || ""}/api/stats`
  )
  if (!res.ok) {
    throw new Error("Network response was not ok")
  }
  return res.json()
}

export default function StatsPage() {
  const { data, status } = useQuery("graphData", fetchStatsData, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3">Stats</Typography>
        <Typography variant="subtitle1">
          Setter leaderboards and first ascents
        </Typography>
      </Box>
      {status === "loading" && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress />
        </Box>
      )}
      {status === "error" && (
        <Typography color="error">Error fetching data</Typography>
      )}
      {status === "success" && (
        <Stats
          setters_all_time={data.setters_all_time}
          setters_by_month={data.setters_by_month}
          first_ascents_by_month={data.first_ascents_by_month}
        />
      )}
    </Box>
  )
}
